import * as React from 'react';
import { useEffect, useState } from 'react';

import ServiceHelper from 'stores/ServiceHelper';
import { Button, Row } from 'saladsoft-primitive';
import { useStoreWrapper } from 'stores/StoreHelper';
import { toast } from 'react-toastify';
import ItemBox from 'components/multiSelectContainer/ItemBox';
import { ItemType } from 'components/multiSelectContainer/types';
import { ItemTypeExtended } from 'types/CommonTypes';

/**
 * 랜드마크 추가 페이지
 * @param checkedLandmarks 이미 선택된 랜드마크
 * @param listingId 시설 ID
 * @returns
 */
const VoucherItemList = ({
  items,
  onChange,
  style,
  usePhoto = true,
}: {
  items?: ItemTypeExtended[];
  onChange?: (items: ItemTypeExtended[]) => void;
  style?: React.CSSProperties;
  usePhoto?: boolean;
}) => {
  const { uiStore } = useStoreWrapper();

  const [candidates, setCandidates] = useState<ItemTypeExtended[]>([]);

  const handleAddItem = (item: ItemTypeExtended, checked: boolean) => {
    if (checked) {
      const isExist = candidates.some((o) => o.id === item.id);
      if (!isExist) {
        setCandidates([...candidates, item]);
      }
    } else {
      setCandidates(candidates.filter((o) => o.id !== item.id));
    }
  };


  useEffect(() => {
    onChange?.(candidates);
  }, [candidates]);

  useEffect(() => {
    setCandidates(items?.filter((o) => o.selected) ?? []);
  }, [items]);

  return (
    <div style={{ ...style }}>

      <Row flexWrap="wrap" width="100%" justifyContent="flex-start" gap="10px">
        {items?.map((item) => (
          <ItemBox
            style={{ width: '100%', maxWidth: 150 }}
            key={item.id}
            item={item}
            onSelect={(item, checked) => {
              handleAddItem(item as ItemTypeExtended, checked)
            }}
            checked={item.selected}
            usePhoto={usePhoto}
          />
        ))}
      </Row>

    </div>
  );
};

export default VoucherItemList;
